import type { VNode } from 'preact';
import MapImage from '@assets/images/map.webp';

interface MapSectionProps {
  onViewLocation?: () => void;
  /** Section id for scroll-to-hash / deep linking */
  id?: string;
}

export function MapSection({ onViewLocation, id }: MapSectionProps): VNode {
  return (
    <section id={id} className="relative w-full overflow-hidden">
      {/* Map background - full width with fixed height */}
      <div className="relative w-full h-[280px] md:h-[350px] 2xl:h-[434px]">
        <img
          src={MapImage}
          alt="Map showing artwork location"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* VIEW LOCATION button overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            type="button"
            onClick={onViewLocation}
            className="bg-transparent px-6 md:px-[30px] py-3 md:py-[14px] h-[46px] md:h-[54px] border-2 border-white text-white font-bold text-base md:text-lg tracking-wide uppercase hover:bg-white/20 active:bg-white/20 focus:bg-white/20 transition-colors flex items-center gap-2.5"
          >
            VIEW LOCATION
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M0 6h14M9 1l5 5-5 5" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
